import { Link } from 'react-router-dom';
import { privacy } from '@/content/et/privacy';
import styles from './PrivacyPage.module.css';

export function PrivacyPage() {
  return (
    <main id="main" className={styles.page}>
      <div className="container">
        <h1 className={styles.title}>{privacy.title}</h1>
        <p className={styles.updated}>
          Viimati uuendatud: {privacy.lastUpdated}
        </p>
        {privacy.sections.map((section) => (
          <section
            key={section.id}
            className={styles.section}
            aria-labelledby={`privacy-${section.id}`}
          >
            <h2 id={`privacy-${section.id}`}>{section.title}</h2>
            {section.body.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </section>
        ))}
        <Link to="/" className={styles.back}>
          ← Avalehele
        </Link>
      </div>
    </main>
  );
}
